var _path, _path2;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgIcon38(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 51,
    height: 41,
    viewBox: "0 0 51 41",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    opacity: 0.4,
    d: "M25.5 0C30.7741 0 35.7746 1.82982 40.1283 5.21745C44.482 8.57789 48.1888 13.5011 50.8507 19.6582C51.0498 20.1255 51.0498 20.672 50.8507 21.1171C45.5268 33.4313 36.0483 40.8 25.5 40.8H25.4751C14.9517 40.8 5.47317 33.4313 0.149268 21.1171C-0.0497561 20.672 -0.0497561 20.1255 0.149268 19.6582C5.47317 7.34153 14.9517 0 25.4751 0H25.5ZM25.5 10.5091C20.002 10.5091 15.5488 14.9353 15.5488 20.4C15.5488 25.84 20.002 30.2662 25.5 30.2662C30.9732 30.2662 35.4263 25.84 35.4263 20.4C35.4263 14.9353 30.9732 10.5091 25.5 10.5091Z",
    fill: "#913BFF"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M31.6993 20.3921C31.6993 23.7797 28.913 26.5492 25.5047 26.5492C22.0715 26.5492 19.2852 23.7797 19.2852 20.3921C19.2852 19.9717 19.3349 19.5786 19.4095 19.1829H19.5339C22.2954 19.1829 24.5344 17.0069 24.6339 14.2845C24.9076 14.2375 25.2061 14.2103 25.5047 14.2103C28.913 14.2103 31.6993 16.9797 31.6993 20.3921Z",
    fill: "#913BFF"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcon38);
export default __webpack_public_path__ + "static/media/icon_38.04618b99df5256bfda21f0b6da6ddc7e.svg";
export { ForwardRef as ReactComponent };